/* eslint-disable no-param-reassign */
import Vue, { VueConstructor } from 'vue';

import HttpService from '@/services/http';

const HttpPlugin = {
  install(Instance: VueConstructor) {
    Instance.prototype.$http = new HttpService();
  },
};

Vue.use(HttpPlugin);
